module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/kinrgy-7f8a02d198774ef5e4d780fbfd107ff3.png";